/* eslint-disable no-param-reassign */

import * as types from './mutationTypes';

export default {
  [types.START_FETCH_ARTICLES](state, { query }) {
    if (query) {
      state.query = {
        ...query,
      };
    }
    state.isFetching = true;
    state.isFetched = false;
    state.error = null;
    state.articles = [];
    state.sArticle = null;
  },

  [types.SET_FETCHED_ARTICLES](state, fetchedArticles) {
    state.isFetching = false;
    state.isFetched = true;
    state.error = null;
    state.articles = fetchedArticles;
  },

  [types.FETCH_ARTICLES_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.error = error;
    state.articles = [];
  },

  [types.START_FETCH_MORE_ARTICLES](state) {
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.isEmpty = false;
  },

  [types.APPEND_FETCHED_ARTICLES](state, fetchedArticles) {
    state.isFetching = false;
    state.isFetched = true;
    state.isEmpty = false;
    state.articles = state.articles.concat(fetchedArticles);
  },

  [types.FETCHED_NULL_ARTICLES](state) {
    state.isFetching = false;
    state.isFetched = true;
    state.isEmpty = true;
    state.articles = state.articles.concat([{ post_id: null }]);
  },

  [types.FETCHED_ARTICLE](state, fetchedarticle) {
    state.isFetching = false;
    state.isFetched = true;
    state.sArticle = fetchedarticle;
  },

  [types.START_FETCH_SINGLE_ARTICLE](state) {
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.sArticle = null;
  },

  [types.SET_FILTER](state, filter) {
    const filters = { ...state.filters, ...filter };
    state.filters = filters;
  },

  [types.UNSET_FILTER](state, filterKey) {
    const filters = {
      ...state.filters,
    };
    delete filters[filterKey];
    state.filters = filters;
    state.selectedArticle = null;
  },

  [types.SET_ICS_TYPE](state, icsType) {
    state.icsType = icsType;
  },
};
